module.exports = __webpack_public_path__ + "img/hand.64168f7b.png";